import { takeLatest, call, all, put } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import snakeCase from 'lodash/snakeCase';
import { dropFirstTimeFlag, unsetFirstTimeFlag } from './actions';

function* dropFlagHandler({ payload: { flag, redirectTo } }: ReturnType<typeof dropFirstTimeFlag>) {
  // Always set the flag to false in the store (false = seen, true/undefined = not seen)
  // This ensures the UI updates immediately, even if the flag was undefined
  yield put(unsetFirstTimeFlag(flag));

  const result = yield call(
    requestPuppy,
    {
      method: 'post',
      url: '/drop_first_time_flag',
      data: { flag: snakeCase(flag) },
    },
    () => ({
      success: true,
    })
  );
  if (result && result.success && redirectTo) {
    window.location.href = redirectTo;
  }
}

export default function* saga() {
  yield all([takeLatest(dropFirstTimeFlag, dropFlagHandler)]);
}
